import { motion } from 'framer-motion';
import type { BattleState, MatchState } from '../../types/kotch';

interface BattleResultsProps {
  battle: BattleState;
  match: MatchState;
  player1Name: string;
  player2Name: string;
  onContinue: () => void;
  isOnline?: boolean;
  isHost?: boolean;
}

export default function BattleResults({
  battle,
  match,
  player1Name,
  player2Name,
  onContinue,
  isOnline = false,
  isHost = false,
}: BattleResultsProps) {
  const getWinnerName = () => {
    if (battle.winnerId === 1) return player1Name;
    if (battle.winnerId === 2) return player2Name;
    return 'Draw';
  };

  const isMatchOver = match.player1BattleWins >= match.battlesToWin ||
                      match.player2BattleWins >= match.battlesToWin;

  return (
    <motion.div
      className="kotch-results"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <h2>Battle {battle.battleNumber} Complete</h2>

      <div className="kotch-winner-banner">
        {getWinnerName()} Wins!
      </div>

      <div className="kotch-results-summary">
        <div className="kotch-result-row">
          <span className="kotch-result-label">Rounds Won</span>
          <span className="kotch-result-value">
            {player1Name}: {battle.player1RoundWins} — {player2Name}: {battle.player2RoundWins}
          </span>
        </div>
        <div className="kotch-result-row">
          <span className="kotch-result-label">Win Reason</span>
          <span className="kotch-result-value">{battle.winReason}</span>
        </div>
        <div className="kotch-result-row">
          <span className="kotch-result-label">Match Score</span>
          <span className="kotch-result-value">
            {player1Name}: {match.player1BattleWins} — {player2Name}: {match.player2BattleWins}
          </span>
        </div>
      </div>

      {!isMatchOver && (
        <p style={{ color: '#8a8a8a' }}>
          First to {match.battlesToWin} battle wins takes the match.
          {match.battlesToWin - Math.max(match.player1BattleWins, match.player2BattleWins)} more win(s) needed.
        </p>
      )}

      {isOnline && !isHost ? (
        <p className="kotch-lobby-waiting-text">Waiting for host to continue...</p>
      ) : (
        <button className="kotch-button" onClick={onContinue}>
          {isMatchOver ? 'View Match Results' : 'Next Battle'}
        </button>
      )}
    </motion.div>
  );
}
